import { z } from "zod";

/** Site-wide booking rules that apply to a person across all boats. */
export const bookingPolicySchema = z.object({
  maxUpcomingReservationsPerPerson: z
    .number({ error: "Upcoming reservations per person must be a number." })
    .int("Upcoming reservations per person must be a whole number.")
    .min(1, "Upcoming reservations per person must be at least 1.")
    .max(20, "Upcoming reservations per person must be at most 20."),
});
export type BookingPolicy = z.infer<typeof bookingPolicySchema>;
